import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./Header"
// import Cookie from "../Cookie"

const Layout = (props) => {
  const { children } = props || {}
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  React.useEffect(() => {
    const hiddenIframes = document.querySelectorAll('iframe[style*="visibility: hidden"]');
    hiddenIframes.forEach((iframe) => {
      iframe.setAttribute('aria-hidden', 'true');
    })
  }, []);

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <main>{children}</main>
      {/* <Cookie /> */}
    </>
  )
}

export default Layout
